import React from 'react';
import styled from 'styled-components';
import { useController } from 'react-hook-form';

import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import fr from 'date-fns/locale/fr';

registerLocale('fr', fr);

type Props = {
  id: string;
  required?: boolean;
  unactive?: boolean;
  label: string;
  minDate?: any;
  placeholder?: string;
};

export const Datepicker = ({
  id,
  label,
  required = false,
  minDate,
  unactive = false,
  placeholder,
}: Props): JSX.Element => {
  const {
    field,
    fieldState: { error },
  } = useController({ name: id });

  return (
    <Container>
      <InputLabel $error={!!error}>
        {label}
        {required && <span>*</span>}
      </InputLabel>

      <CustomDatePicker
        {...field}
        disabled={unactive}
        dropdownMode="select"
        showMonthDropdown
        showYearDropdown
        placeholderText={placeholder || new Date().toLocaleDateString('fr')}
        selected={field.value}
        onChange={(date) => field.onChange(date)}
        minDate={minDate || new Date()}
        maxDate={new Date('2050-01-01')}
        locale="fr"
        dateFormat="dd/MM/yyyy"
        $error={!!error}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const CustomDatePicker = styled(DatePicker)<{ $error: boolean }>`
  position: relative;
  width: 100%;
  padding: 0.7rem 0.5rem 0.7rem 0.6rem;
  font-weight: 500;
  background-color: white;
  border-radius: 0.5rem;
  box-sizing: border-box;
  font-size: 0.9rem;
  border: 0.1rem solid ${({ $error }) => ($error ? 'red' : '#d1d5db')};
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  &:focus {
    outline: none;
    border-bottom: 0.2rem solid ${({ $error }) => ($error ? 'red' : '#154077')};
  }
  &:disabled {
    box-shadow: none;
    background-color: #d2d7d3;
    opacity: 0.9;
    cursor: default;
  }
`;

const InputLabel = styled.label<{ $error: boolean }>`
  line-height: 1.25rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ $error }) => ($error ? 'red' : '#154077')};
  margin-bottom: 0.5rem;
  & > span {
    margin-left: 0.2rem;
  }
`;
